import { __decorate } from "tslib";
import _ from 'lodash';
import { injectable } from 'inversify';
import { Timezones } from '../@core/utils/timezone';
import { Countries } from '../libs/countries';
import { E_Language, E_CompanyArea } from '../apis/service/types';
let CommonService = class CommonService {
    get TimezonesSelect() {
        return _.map(Timezones, t => {
            return {
                ...t,
                text: t.label,
                value: t.value,
                offset: t.utc_offset,
            };
        });
    }
    get CountriesSelect() {
        return Countries;
    }
    get AreaSelect() {
        return [
            E_CompanyArea.EAST,
            E_CompanyArea.WEST
        ];
    }
    get LanguageSelect() {
        return [
            E_Language.en_US,
            E_Language.zh_CN,
            E_Language.zh_TW,
            E_Language.ja_JP
        ];
    }
};
CommonService = __decorate([
    injectable()
], CommonService);
export { CommonService };
